import { Button } from 'common-components'
import * as Styled from './styled'
import { IButtonsConfig } from '../types'
import { AnimatePresence } from 'framer-motion'
import { memo } from 'react'
import { useConfirmButtonTooltip } from './useConfirmButtonTooltip'

const FRAMER_ANIMATION_PROPS = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.2 }
}

interface IProps {
  buttonsConfig: IButtonsConfig
  isTooltipVisible?: boolean
  alertTooltipText?: string
}

const TtsFlyoutActionButtons = ({
  buttonsConfig,
  isTooltipVisible,
  alertTooltipText
}: IProps) => {
  const { confirmButton, cancelButton } = buttonsConfig

  const { showTooltip } = useConfirmButtonTooltip(
    !!(isTooltipVisible && alertTooltipText)
  )

  return (
    <Styled.TtsFlyoutActionButtonsContainer>
      <Button
        className="button cancel-button"
        type="white"
        onClick={cancelButton.onClick}
        isDisabled={cancelButton.disabled}
      >
        {cancelButton.title}
      </Button>

      <Styled.ButtonWithTooltipWrapper>
        <Button
          className="button confirm-button"
          type="light"
          onClick={confirmButton.onClick}
          isDisabled={confirmButton.disabled}
        >
          {confirmButton.title}
        </Button>
        <AnimatePresence>
          {showTooltip && (
            <Styled.CustomTooltipWrapper {...FRAMER_ANIMATION_PROPS}>
              {alertTooltipText}
              <Styled.TooltipArrow />
            </Styled.CustomTooltipWrapper>
          )}
        </AnimatePresence>
      </Styled.ButtonWithTooltipWrapper>
    </Styled.TtsFlyoutActionButtonsContainer>
  )
}
export default memo(TtsFlyoutActionButtons)
